import {request} from './request'


export function getAreaUnit(area = '全国') {
    return request({
        url: '/hp/compile-unit-analysis/area/',
        params: {
            area,
        }
    });
}


export function getUnitRank(area='全国', recently = '全部时间') {
    return request({
        url: '/hp/compile-unit-analysis/performance/',
        params: {
            area,
            recently,
        }
    });
}

export function getUnitAvg(recently = '全部时间') {
    return request({
        url: '/hp/compile-unit-analysis/province-avg-performance/',
        params: {
            recently,
        }
    });
}


export function getAreaHost(area = '全国') {
    return request({
        url: '/hp/compile-host-analysis/area/',
        params: {
            area,
        }
    });
}


export function getHostRank(area='全国', recently = '全部时间') {
    return request({
        url: '/hp/compile-host-analysis/performance/',
        params: {
            area,
            recently,
        }
    });
}


export function getHostAvg(recently = '全部时间') {
    return request({
        url: '/hp/compile-host-analysis/province-avg-performance/',
        params: {
            recently,
        }
    });
}